document.addEventListener("DOMContentLoaded", () => {
    
    const carousels = document.querySelectorAll(".carousel-document-block .swiper");
    
    carousels.forEach((carousel) => {
        let block = carousel.closest('.carousel-document-block');
        let blockId = block.id;
        let scrollbar = document.querySelector(`#${blockId} .swiper-scrollbar`);
        let type = block.dataset.type; // Detecta el data-type
        let carouselImgs = document.querySelectorAll(`#${blockId} .swiper-slide img`);

        let swiperConfig = {
            slidesPerView: "auto",
            setWrapperSize: true,
        };

        if (type === "reports") {
            swiperConfig.navigation = {
                nextEl: `#${blockId} .swiper-button-next`,
                prevEl: `#${blockId} .swiper-button-prev`,
            };
        } else {
            swiperConfig.scrollbar = {
                el: scrollbar,
                draggable: true,
            };
        }

        new Swiper(carousel, swiperConfig);

        carouselImgs.forEach((img) => {
            const carouselImgAnim = gsap.timeline({
                scrollTrigger: {
                    trigger: img,
                    start: "top bottom",
                    end: "bottom 50%",
                    scrub: true,
                },
            });

            carouselImgAnim.to(
                img,
                {
                    scale: 1.1,
                    duration: 1,
                    ease: "expo.inOut",
                },
                "<"
            );
        });
    });
});
